import { useCallback, useEffect, useState } from "react"
import { EdPexApis, missionList } from "../../../../api/edpx/ed_px.api";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { DashboardsApi, miniTableQueryType } from "../../../../api/edpex-dashboard/dashboard.api";
import StatusCustom from "../../../../components/status/statusCustom";
import { ed_pex_project_status_data, EDPEX_PROJECT_STATUS } from "../enum/enum";
import { saveAs } from "file-saver";
import { alertError } from "../../../../components/alert/swal";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../../store/loading/loading.slice";
import { getSurroundingYears } from "../../../../utils/app.utils";
import moment from "moment";


const status_name: { key: string, color: string, name: string }[] = [
    {
        color: "rgba(0,0,0,0.1)",
        key: EDPEX_PROJECT_STATUS.DRAFT,
        name: "ร่าง"
    },
    {
        color: "#FFC772",
        key: EDPEX_PROJECT_STATUS.PENDING_PROCESS,
        name: "รอดำเนินการ"
    },
    {
        color: "#94CFF9",
        key: EDPEX_PROJECT_STATUS.PROCESS,
        name: "กำลังดำเนินการ"
    },
    {
        color: "#FF8D8D",
        key: EDPEX_PROJECT_STATUS.OVERDUE,
        name: "เกินกำหนดระยะเวลา"
    },
    {
        color: "#5FB95D",
        key: EDPEX_PROJECT_STATUS.COMPLETED,
        name: "ดำเนินการเสร็จสิ้น"
    },
]
export const ManageState = () => {
    const dispatch = useDispatch();

    const [step, setStep] = useState<number>(0);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [pageEdPex, setPageEdPex] = useState<number>(1);
    const [pageLimitEdPex, setPageLimitEdPex] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [totalItemsEdPex, setTotalItemsEdPex] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [search, setSearch] = useState<string>("");
    const [key_loading, set_key_loading] = useState<boolean>(false);
    const [data, setData] = useState<any[]>([]);
    const [standard_point_data, set_standard_point_data] = useState<any[]>([]);
    const [id_edpex_standard_point, set_id_edpex_standard_point] = useState<number | null>(null);
    const [detailProject, setDetailProject] = useState<any>(null);
    const [pageDetail, setPageDetail] = useState<number>(1);


    const [start_year, set_start_year] = useState<number | null>(0);
    const [end_year, set_end_year] = useState<number | null>(0);
    const [ed_pex_status, set_ed_pex_status] = useState<string>("");
    const [department_responsible, set_department_responsible] = useState<string | null>(null);

    const [searchEdPex, setSearchEdPex] = useState<string>("");
    const [start_year_ed_pex, set_start_year_ed_pex] = useState<number | null>(0);
    const [status_ed_pex_data, set_status_ed_pex_data] = useState<string>("");
    const [department_responsible_ed_pex, set_department_responsible_ed_pex] = useState<string | null>(null);


    const [filterId, setFilterId] = useState<{
        dashboard_mission: number[];
        dashboard_quarter: string[];
        dashboard_deputy_director_responsible: string[];
        dashboard_department: number[]
    }>({
        dashboard_mission: [],
        dashboard_quarter: [],
        dashboard_deputy_director_responsible: [],
        dashboard_department: []
    })
    const [filterData, setFilterData] = useState<{
        project_count: number;
        dashboard_mission: { edpex_mission_name: string, count_val: string, id_edpex_mission: number }[];
        dashboard_budget: { edpex_project_budget_all: string, edpex_project_budget_balance: string, edpex_project_budget_use: string };
        dashboard_quarter: { count_val: string, edpex_quarter: string }[];
        dashboard_department: { count_val: string, edpex_project_department_responsible: string, id_department: number }[];
        dashboard_project_status: { count_val: string, edpex_project_status: string | null, color: string, name: string }[];
        dashboard_budget_mission: { edpex_mission_data: any[], edpex_project_budget_all: number[], edpex_project_budget_balance: number[], edpex_project_budget_use: number[] };
        dashboard_deputy_director_responsible: { count_val: string, edpex_project_user_responsible: string }[];
    }>({
        project_count: 0,
        dashboard_mission: [],
        dashboard_budget: {
            edpex_project_budget_all: "",
            edpex_project_budget_balance: "",
            edpex_project_budget_use: ""
        },
        dashboard_quarter: [],
        dashboard_department: [],
        dashboard_project_status: [],
        dashboard_budget_mission: {
            edpex_mission_data: [],
            edpex_project_budget_all: [],
            edpex_project_budget_balance: [],
            edpex_project_budget_use: []
        },
        dashboard_deputy_director_responsible: [],
    })

    const year_data = getSurroundingYears(moment().year())

    const [dataMini, setDataMini] = useState<any[]>([]);

    const handleRequestSort = (sb: string, st: string) => {
        setSortBy(sb);
        setSortType(st);
    }


    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            edpex_mission_name,
            edpex_project_name,
            edpex_project_status,
            edpex_project_budget_use,
            edpex_quarter,
            responsible_name,
            edpex_project_budget_all,
            edpex_project_budget_balance
        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: edpex_mission_name || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: edpex_project_name || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: <StatusCustom
                        sx={{ maxWidth: 'fit-content' }}
                        text={ed_pex_project_status_data?.find((x) => x.value === edpex_project_status)?.label || "-"}
                        type={ed_pex_project_status_data?.find((x) => x.value === edpex_project_status)?.label || "-"}
                    />
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: edpex_quarter || "-",
                },
                {
                    option: "PRICE",
                    align: "center",
                    label: edpex_project_budget_all ? edpex_project_budget_all : "0"
                },
                {
                    option: "PRICE",
                    align: "center",
                    label: edpex_project_budget_use || "0"
                },
                {
                    option: "PRICE",
                    align: "center",
                    label: edpex_project_budget_balance || "0"
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: responsible_name || "-"
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const headCells = [
        {
            id: "subject_no", width: 200, disablePadding: false, align: 'center', label: "พันธกิจ"
        },
        {
            id: "subject_name", disablePadding: false, width: 200, align: "center", label: "โครงการ/กิจกรรม/งานที่รับผิดชอบ"
        },
        {
            id: "subject_credit", disablePadding: false, align: "center", width: 150, label: "รายละเอียดสถานะดำเนินการ"
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 100, label: "ไตรมาส"
        },
        {
            id: "status1", disablePadding: false, align: "center", width: 100, label: "งบที่ตั้งไว้"
        },
        {
            id: "status2", disablePadding: false, align: "center", width: 100, label: "ใช้ไปแล้ว"
        },
        {
            id: "status3", disablePadding: false, align: "center", width: 100, label: "งบคงเหลือ"
        },
        {
            id: "status4", disablePadding: false, align: "center", width: 100, label: "ผู้เกี่ยวข้อง"
        },
    ];
    const headCellAll = [
        {
            id: "subject_no", width: 150, disablePadding: false, align: 'center', label: "เกณฑ์ Edpex"
        },
        {
            id: "subject_name", disablePadding: false, width: 200, align: "center", label: "เกณฑ์คะแนน"
        },
        {
            id: "subject_credit", disablePadding: false, align: "center", width: 100, label: "พันธกิจ"
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 100, label: "โครงการ/กิจกรรม/)งานที่รับผิดชอบ"
        },
        {
            id: "1", disablePadding: false, align: "center", width: 100, label: "งมประมาณ"
        },
        {
            id: "2", disablePadding: false, align: "center", width: 100, label: "ส่วนงานที่รับผิดชอบ"
        },
        {
            id: "3", disablePadding: false, align: "center", width: 100, label: "สำนักงานที่รับผิดชอบ"
        },
        {
            id: "4", disablePadding: false, align: "center", width: 100, label: "รองผอ.ผู้รับผิดชอบ"
        },
        {
            id: "5", disablePadding: false, align: "center", width: 100, label: "การดำเนินการ"
        },
        {
            id: "6", disablePadding: false, align: "center", width: 150, label: "ตัวชี้วัด"
        },
        {
            id: "7", disablePadding: false, align: "center", width: 150, label: "ค่าเป้าหมาย"
        },
        {
            id: "8", disablePadding: false, align: "center", width: 150, label: "ผลลัพธ์ค่าเป้าหมาย"
        },
        {
            id: "9", disablePadding: false, align: "center", width: 100, label: "กลุ่มเป้าหมาย"
        },
        {
            id: "10", disablePadding: false, align: "center", width: 100, label: "ผลลัพธ์ EdPEx"
        },
        {
            id: "10.1", disablePadding: false, align: "center", width: 70, label: "ปีงบประมาณ"
        },
    ];
    const headCellAllNext = [
        {
            id: "11", disablePadding: false, align: "center", width: 100, label: "ผู้เกี่ยวข้อง"
        },
        {
            id: "12", disablePadding: false, align: "center", width: 100, label: "หมายเหตุ"
        },
        {
            id: "13", disablePadding: false, align: "center", width: 100, label: "สถานะ"
        },
    ]



    const handleGetDataMini = useCallback(async (query_filter: {
        keyword?: string;
        start_year?: string;
        end_year?: string;
        edpex_project_status?: string;
        edpex_project_division_responsible?: string;
    }) => {
        const { keyword, edpex_project_status, end_year, start_year } = query_filter
        let query: miniTableQueryType = {
            page: page,
            limit: pageLimit,
        }
        if (keyword) query = { ...query, keyword: keyword }
        if (start_year) query = { ...query, fiscal_year_start: String(start_year) }
        if (end_year) query = { ...query, fiscal_year_end: String(end_year) }
        if (edpex_project_status) query = { ...query, edpex_project_status: edpex_project_status }
        if (filterId.dashboard_mission.length > 0) {
            query = { ...query, id_edpex_missions: filterId.dashboard_mission.map((list) => String(list)).join("|") }
        }
        if (filterId.dashboard_department.length > 0) {
            query = { ...query, edpex_project_user_responsibles: filterId.dashboard_department.map((list) => String(list)).join("|") }
        }
        if (filterId.dashboard_quarter.length > 0) {
            query = { ...query, edpex_quarters: filterId.dashboard_quarter.map((list) => String(list)).join("|") }
        }
        if (filterId.dashboard_deputy_director_responsible.length > 0) {
            query = { ...query, edpex_project_department_responsibles: filterId.dashboard_deputy_director_responsible.map((list) => String(list)).join("|") }
        }
        dispatch(setLoading());
        await DashboardsApi.miniTable(query).then((res) => {
            if (res.status < 300) {
                const data_value = res.data?.data?.items || [];
                const total_items = res.data?.data?.meta?.totalItems || 0;
                set_key_loading(true);
                setTotalItems(total_items);
                setDataMini(data_value);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            if (key_loading) {
                dispatch(unsetLoading());
            } else {
                setTimeout(() => {
                    dispatch(unsetLoading());
                }, 600)
            }
        })
    }, [page, pageLimit, filterId])

    const handleGetEdPexData = useCallback(async () => {
        let query: miniTableQueryType = {
            page: pageEdPex,
            limit: pageLimitEdPex
        }
        if (searchEdPex) query = { ...query, keyword: searchEdPex }
        if (start_year_ed_pex) query = { ...query, fiscal_year_start: String(start_year_ed_pex) }
        if (status_ed_pex_data) query = { ...query, edpex_project_status: status_ed_pex_data }
        if (id_edpex_standard_point) query = { ...query, id_edpex_standard_point: id_edpex_standard_point }
        if (department_responsible_ed_pex) query = { ...query, edpex_project_division_responsible: department_responsible_ed_pex }
        await DashboardsApi.reportDataTable(query).then((res) => {
            if (res.status < 300) {
                const totalItems = res.data?.data?.meta?.totalItems || 0;
                const items_data = res.data?.data?.items?.map((list: any) => {
                    const start_year = moment(list?.edpex_project_start_date);
                    const end_year = moment(list?.edpex_project_end_date);

                    const formatMonth = (
                        day: number | undefined,
                        monthIndex: number,
                        value: string | number | undefined,
                        year: number
                    ): string => {
                        if (!day) return '';
                        return `${moment({ year, month: monthIndex, day }).format('D MMM')} ${value || '-'}`;
                    };
                    const result_start = [
                        formatMonth(list?.oct, 9, list?.u_oct, start_year.year()), // ต.ค.
                        formatMonth(list?.nov, 10, list?.u_nov, start_year.year()), // พ.ย.
                        formatMonth(list?.decm, 11, list?.u_decm, start_year.year()), // ธ.ค.
                    ]
                    const result_end = [
                        formatMonth(list?.jan, 0, list?.u_jan, start_year.year()), // ม.ค.
                        formatMonth(list?.feb, 1, list?.u_feb, start_year.year()), // ก.พ.
                        formatMonth(list?.mar, 2, list?.u_mar, start_year.year()), // มี.ค.
                        formatMonth(list?.apr, 3, list?.u_apr, start_year.year()), // เม.ย.
                        formatMonth(list?.may, 4, list?.u_may, start_year.year()), // พ.ค.
                        formatMonth(list?.jun, 5, list?.u_jun, start_year.year()), // มิ.ย.
                        formatMonth(list?.jul, 6, list?.u_jul, start_year.year()), // ก.ค.
                        formatMonth(list?.aug, 7, list?.u_aug, start_year.year()), // ส.ค.
                        formatMonth(list?.sep, 8, list?.u_sep, start_year.year()), // ก.ย.

                    ];
                    return {
                        ...list,
                        graph_data: [
                            {
                                year: start_year.add(543, 'year').year(), months: result_start
                            },
                            {
                                year: end_year.add(543, 'year').year(), months: result_end
                            },
                        ]

                    }
                });
                setData(items_data);
                setTotalItemsEdPex(totalItems)
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [pageEdPex, pageLimitEdPex, searchEdPex, start_year_ed_pex, status_ed_pex_data, id_edpex_standard_point, department_responsible_ed_pex])

    const handleGetFilterAll = async () => {
        await DashboardsApi.allFilter().then((res) => {
            if (res.status < 300) {
                const data = res.data?.data || null;
                if (data) {
                    const dashboard_budget_mission: any[] = data?.dashboard_budget_mission || [];
                    const dashboard_deputy_director_responsible_data: any[] = data?.dashboard_deputy_director_responsible || [];
                    const dashboard_department: any[] = data?.dashboard_department || [];
                    const id_dashboard_mission: number[] = data?.dashboard_mission?.filter((x: any) => x?.id_edpex_mission).map((list: any) => list?.id_edpex_mission) || [];
                    const department: number[] = data?.dashboard_department?.filter((x: any) => x?.edpex_project_department_responsible).map((list: any) => list?.edpex_project_department_responsible) || [];
                    const dashboard_quarter: string[] = data?.dashboard_quarter?.filter((x: any) => x?.edpex_quarter).map((list: any) => list?.edpex_quarter) || [];
                    const dashboard_deputy_director_responsible: string[] = data?.dashboard_deputy_director_responsible?.filter((x: any) => x?.edpex_project_user_responsible).map((list: any) => list?.edpex_project_user_responsible) || [];
                    setFilterId({
                        dashboard_mission: id_dashboard_mission,
                        dashboard_quarter: dashboard_quarter,
                        dashboard_deputy_director_responsible: dashboard_deputy_director_responsible,
                        dashboard_department: department
                    })
                    setFilterData((prev) => ({
                        ...prev,
                        project_count: data?.project_count || 0,
                        dashboard_mission: data?.dashboard_mission || [],
                        dashboard_budget: data?.dashboard_budget,
                        dashboard_quarter: data?.dashboard_quarter || [],
                        dashboard_department: dashboard_department || [],
                        dashboard_project_status: data?.dashboard_project_status?.map((list: any) => {
                            return {
                                y: list?.count_val ? +list?.count_val : 0,
                                name: status_name?.find((x) => x.key === list?.edpex_project_status)?.name || "-",
                                color: status_name?.find((x) => x.key === list?.edpex_project_status)?.color || "",
                            }
                        }) || [],
                        dashboard_budget_mission: {
                            edpex_mission_data: dashboard_budget_mission,
                            edpex_project_budget_all: dashboard_budget_mission?.map((list) => Number(list?.edpex_project_budget_all || 0)),
                            edpex_project_budget_balance: dashboard_budget_mission?.map((list) => Number(list?.edpex_project_budget_all || 0)),
                            edpex_project_budget_use: dashboard_budget_mission?.map((list) => Number(list?.edpex_project_budget_use || 0)),
                        },
                        dashboard_deputy_director_responsible: dashboard_deputy_director_responsible_data
                    }))
                }
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const handleFindDetailProject = async (id_edpex_project: number) => {
        dispatch(setLoading());
        await DashboardsApi.findOneProjectEdPex(id_edpex_project).then((res) => {
            if (res.status < 300) {
                const data_value = res.data?.data || [];
                setDetailProject(data_value)
                console.log(res.data, 'detailProject')
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleFindIndicatorEdPex = async () => {
        await DashboardsApi.findEdPexStandard().then((res) => {
            if (res.status < 300) {
                const data_value = res.data?.data || [];
                set_standard_point_data(data_value);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const handleExportReportData = async () => {
        let query: miniTableQueryType = {
            page: page,
            limit: pageLimit
        }
        dispatch(setLoading());
        await DashboardsApi.excelReport(query).then((res) => {
            if (res.status < 300) {
                const data_value = res.data;
                const blob_file = new Blob([data_value], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
                saveAs(blob_file, 'report_ed_pex_รายงาน_ระบบ_ed_pex')
            }
        }).catch((err) => {
            console.log(err)
            alertError("ดาวน์โหลดไฟล์ไม่สำเร็จ")
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    useEffect(() => {
        handleGetDataMini({});
    }, [handleGetDataMini])

    useEffect(() => {
        handleGetEdPexData()
    }, [handleGetEdPexData])

    useEffect(() => {
        handleFindIndicatorEdPex();
        handleGetFilterAll();
    }, [])
    return {
        page,
        pageLimit,
        sortBy,
        sortType,
        data,
        totalItems,
        setPage,
        setPageLimit,
        headCells,
        renderData,
        handleRequestSort,
        step,
        setStep,
        headCellAll,
        headCellAllNext,
        dataMini,
        handleExportReportData,
        setSearch,
        year_data,
        filterData,
        start_year,
        set_start_year,
        end_year,
        set_end_year,
        ed_pex_status,
        set_ed_pex_status,
        filterId,
        setFilterId,
        handleGetDataMini,
        pageEdPex,
        setPageEdPex,
        setPageLimitEdPex,
        pageLimitEdPex,
        search,
        department_responsible,
        set_department_responsible,
        totalItemsEdPex,

        setSearchEdPex,
        start_year_ed_pex,
        set_start_year_ed_pex,
        status_ed_pex_data,
        set_status_ed_pex_data,
        set_department_responsible_ed_pex,
        department_responsible_ed_pex,
        standard_point_data,
        id_edpex_standard_point,
        set_id_edpex_standard_point,
        handleFindDetailProject,
        detailProject,
        pageDetail,
        setPageDetail
    }
}